module.exports = __webpack_public_path__ + "static/home02-919f7567e6df995759e481d483b2cfba.png";